/* Scoped enhancement; links remain usable if JavaScript is unavailable. */
if (!customElements.get('bv-care-finder')) {
  customElements.define('bv-care-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.choices = Array.from(this.querySelectorAll('[data-bv-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-bv-panel]'));
      this.choices.forEach((choice, index) => {
        choice.setAttribute('role', 'button');
        choice.setAttribute('aria-pressed', String(index === 0));
      });
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-bv-choice]');
        if (!choice || !this.contains(choice) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.choose(choice);
      });
      this.addEventListener('keydown', (event) => {
        const choice = event.target.closest('[data-bv-choice]');
        if (choice && this.contains(choice) && event.key === ' ') {
          event.preventDefault();
          this.choose(choice);
        }
      });
    }
    choose(choice) {
      const key = choice.dataset.bvChoice;
      this.choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.bvPanel !== key; });
    }
  });
}
